/* 表情原图配置文件 */
// import config from './index'

let emojiBaseUrl = 'https://files.wondercv.com'

let emojiList = {
  "emoji": {
    '[大笑]': { file: 'emoji_00.png' },
    '[可爱]': { file: 'emoji_01.png' },
    '[色]': { file: 'emoji_02.png' },
    '[嘘]': { file: 'emoji_03.png' },
    '[亲]': { file: 'emoji_04.png' },
    '[呆]': { file: 'emoji_05.png' },
    '[口水]': { file: 'emoji_06.png' },
    '[汗]': { file: 'emoji_145.png' },
    '[呲牙]': { file: 'emoji_07.png' },
    '[鬼脸]': { file: 'emoji_08.png' },
    '[害羞]': { file: 'emoji_09.png' },
    '[偷笑]': { file: 'emoji_10.png' },
    '[调皮]': { file: 'emoji_11.png' },
    '[可怜]': { file: 'emoji_12.png' },
    '[敲]': { file: 'emoji_13.png' },
    '[惊讶]': { file: 'emoji_14.png' },
    '[流感]': { file: 'emoji_15.png' },
    '[委屈]': { file: 'emoji_16.png' },
    '[流泪]': { file: 'emoji_17.png' },
    '[嚎哭]': { file: 'emoji_18.png' },
    '[惊恐]': { file: 'emoji_19.png' },
    '[怒]': { file: 'emoji_20.png' },
    '[酷]': { file: 'emoji_21.png' },
    '[不说]': { file: 'emoji_22.png' },
    '[鄙视]': { file: 'emoji_23.png' },
    '[阿弥陀佛]': { file: 'emoji_24.png' },
    '[奸笑]': { file: 'emoji_25.png' },
    '[睡着]': { file: 'emoji_26.png' },
    '[口罩]': { file: 'emoji_27.png' },
    '[努力]': { file: 'emoji_28.png' },
    '[抠鼻孔]': { file: 'emoji_29.png' },
    '[疑问]': { file: 'emoji_30.png' },
    '[怒骂]': { file: 'emoji_31.png' },
    '[晕]': { file: 'emoji_32.png' },
    '[呕吐]': { file: 'emoji_33.png' },
    '[拜一拜]': { file: 'emoji_160.png' },
    '[惊喜]': { file: 'emoji_161.png' },
    '[流汗]': { file: 'emoji_162.png' },
    '[卖萌]': { file: 'emoji_163.png' },
    '[默契眨眼]': { file: 'emoji_164.png' },
    '[烧香拜佛]': { file: 'emoji_165.png' },
    '[晚安]': { file: 'emoji_166.png' },
    '[强]': { file: 'emoji_34.png' },
    '[弱]': { file: 'emoji_35.png' },
    '[OK]': { file: 'emoji_36.png' },
    '[拳头]': { file: 'emoji_37.png' },
    '[胜利]': { file: 'emoji_38.png' },
    '[鼓掌]': { file: 'emoji_39.png' },
    '[握手]': { file: 'emoji_200.png' },
    '[发怒]': { file: 'emoji_40.png' }
  }
}

for (let emoji in emojiList) {
  let emojiItem = emojiList[emoji]
  for (let key in emojiItem) {
    let item = emojiItem[key]
    item.img = `${emojiBaseUrl}/${emoji}/${item.file}`
  }
}

let pinupList = {
  'ajmd':{},
  'xxy': {},
  'lt': {}
}

for (let i = 1; i <= 48; i++) {
  let key = 'ajmd0'+ (i >= 10 ? i: '0' + i)
  pinupList['ajmd'][key] = {file: key + '.png'}
}
for (let i = 1; i <= 40; i++) {
  let key = 'xxy0'+ (i >= 10 ? i: '0' + i)
  pinupList['xxy'][key] = {file: key + '.png'}
}
for (let i = 1; i <= 20; i++) {
  let key = 'lt0'+ (i >= 10 ? i: '0' + i)
  pinupList['lt'][key] = {file: key + '.png'}
}

for (let emoji in pinupList) {
  let emojiItem = pinupList[emoji]
  for (let key in emojiItem) {
    let item = emojiItem[key]
    item.img = `${emojiBaseUrl}/${emoji}/${item.file}`
  }
}

export default {
  emojiList,
  pinupList
}